import { render, staticRenderFns } from "./ImageAdmin.vue?vue&type=template&id=78ef5f5c&scoped=true&"
import script from "./ImageAdmin.vue?vue&type=script&lang=js&"
export * from "./ImageAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ef5f5c",
  null
  
)

export default component.exports